const getApiBaseUrl = () => {
  // If REACT_APP_API_BASE_URL is set directly, use it
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  // Otherwise, determine based on REACT_APP_ENV
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'production';
  const configs = {
    development: 'http://localhost:3000',
    test: 'https://nusa-ex-blastoff-usea-app.azurewebsites.net',
    production: 'https://dnaanalysiskit.petivitybrands.com'
  };
  return configs[env] || configs.production;
};
export const APIURL = getApiBaseUrl();
// For backwards compatibility
export const API_BASE_URL = APIURL;